import RoutesWrapper from "./containers/RoutesWrapper";
import { IntlProvider } from "react-intl";

import itTexts from "./translations/it.json";
import enTexts from "./translations/en.json";

import { getBrowserNavigatorLanguage } from "./shared/storage";
import { useCallback, useEffect, useMemo } from "react";
import { useLocation } from "react-router-dom";

const messages: { [key: string]: typeof enTexts } = {
  it: itTexts,
  en: enTexts,
};

let language = getBrowserNavigatorLanguage();

if (!messages[language]) {
  language = Object.keys(messages)[0];
}

// Force english at this moment. Remove this line in future
language = "en";

function App() {
  const location = useLocation();

  const slicePath = useCallback(
    (val: 1 | 2) => location.pathname.split("/").slice(val).join("/"),
    [location.pathname]
  );

  const filteredPath = useMemo(() => {
    const path = slicePath(2);
    return isNaN(+path.at(-1)!)
      ? path.length
        ? path
        : slicePath(1)
      : path.length
      ? path.substring(0, path.lastIndexOf("/"))
      : slicePath(1).substring(0, path.lastIndexOf("/"));
  }, [slicePath]);

  useEffect(() => {
    // @ts-ignore
    window.rudderanalytics.page(filteredPath);
  }, [filteredPath]);

  return (
    <IntlProvider
      defaultLocale="en"
      locale={language}
      messages={messages[language] || messages["en"]}
    >
      <RoutesWrapper />
    </IntlProvider>
  );
}

export default App;
